<template>
  <div id="Bidinput">
    <div class="title">
      <h2>破产案件投标录入</h2>
    </div>
    <div class="main">
      <el-card class="main_card">
        <div class="case">
          <div class="contain">
            <el-form
              class="form"
              :rules="rules"
              ref="ruleForm"
              :model="form"
              label-width="150px"
            >
              <div class="top">
                <div class="icon"></div>
                <div>案件信息</div>
              </div>
              <el-row>
                <el-form-item label="项目名称" prop="title">
                  <el-input
                    v-model="form.title"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </el-row>
              <el-row>
                <el-form-item label="项目概要" prop="cause">
                  <el-input
                    v-model="form.cause"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </el-row>
              <el-row>
                <el-col :span="6">
                  <el-form-item label="案件编号" prop="code">
                    <el-input
                      v-model="form.code"
                      placeholder="自动编号"
                      disabled
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="受理状态" prop="casestatus">
                    <el-select
                      v-model="form.casestatus"
                      placeholder="请选择"
                      class="select"
                    >
                      <el-option
                        v-for="item in CaseStatus"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>

                <el-col :span="6">
                  <el-form-item label="项目合伙人" prop="extInfo.partner">
                    <el-input
                      v-model="form.extInfo.partner"
                      placeholder="请输入"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="底稿资料" prop="extInfo.draft">
                    <el-select
                      v-model="form.extInfo.draft"
                      placeholder="请选择"
                      class="select"
                    >
                      <el-option
                        v-for="item in Draft"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <div class="divider"></div>
              <el-row>
                <el-col :span="6" class="date_box">
                  <el-form-item label="立项日期" prop="postTime">
                    <div
                      class="date_box"
                      @mouseover="onMouseOver()"
                      @mouseleave="onMouseleave()"
                    >
                      <el-date-picker
                        style="width: 100%"
                        value-format="yyyy-MM-dd"
                        v-model="form.postTime"
                        type="date"
                        placeholder="请选择日期"
                      >
                      </el-date-picker>
                      <i class="el-icon-date" ref="iconDate"></i>
                    </div>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="项目来源" prop="source">
                    <el-input
                      v-model="form.source"
                      placeholder="请输入"
                    ></el-input>
                  </el-form-item>
                </el-col>

                <el-col :span="6">
                  <el-form-item label="代理机构" prop="acceptUnit">
                    <el-input
                      v-model="form.acceptUnit"
                      placeholder="请输入"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="受理机构案号" prop="acceptCode">
                    <el-input
                      v-model="form.acceptCode"
                      placeholder="请输入"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="6">
                  <el-form-item label="项目类型" prop="extInfo.projecttype">
                    <el-select
                      style="width: 100%"
                      v-model="form.extInfo.projecttype"
                      placeholder="请选择"
                      class="select"
                    >
                      <el-option
                        v-for="item in ProjectType"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="服务律师" prop="LeadLawyer">
                    <el-select
                      multiple
                      :multiple-limit="1"
                      filterable
                      style="width: 100%"
                      v-model="form.LeadLawyer"
                      placeholder="请选择"
                      class="select"
                      @change="selectChange('1')"
                    >
                      <el-option
                        v-for="item in computeDifferenceSet(form.LeadLawyer)"
                        :key="item.id"
                        :label="item.nikename"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="服务律师" prop="CoCounsel">
                    <el-select
                      multiple
                      filterable
                      style="width: 100%"
                      v-model="form.CoCounsel"
                      placeholder="请选择"
                      class="select"
                      @change="selectChange()"
                    >
                      <el-option
                        v-for="item in computeDifferenceSet(form.CoCounsel)"
                        :key="item.id"
                        :label="item.nikename"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="开放时间" prop="extInfo.opentime">
                    <div
                      class="date_box"
                      @mouseover="onMouseOverOpen()"
                      @mouseleave="onMouseleave()"
                    >
                      <el-date-picker
                        style="width: 100%"
                        v-model="form.extInfo.opentime"
                        value-format="yyyy-MM-dd"
                        type="date"
                        placeholder="请选择日期"
                      >
                      </el-date-picker>
                      <i class="el-icon-date" ref="openDate"></i>
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="6">
                  <el-form-item label="采购方式" prop="extInfo.procuremethod">
                    <el-input
                      placeholder="请输入"
                      v-model="form.extInfo.procuremethod"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="采购编号" prop="extInfo.procurecode">
                    <el-input
                      v-model="form.extInfo.procurecode"
                      placeholder="请输入"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="预算金额" prop="extInfo.budgetmoney">
                    <el-input
                      v-model="form.extInfo.budgetmoney"
                      placeholder="请输入"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="部门审批人" prop="departmentLeaders">
                    <el-select
                      style="width: 100%"
                      v-model="form.departmentLeaders"
                      placeholder="请先选择代理律师"
                      class="select"
                      filterable
                    >
                      <el-option
                        v-for="item in depLeaders"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>

                <el-col :span="12">
                  <el-form-item label="二次审批人" prop="approve">
                    <el-select
                      style="width: 100%"
                      v-model="form.approve"
                      placeholder="请先选择服务律师"
                      class="select"
                      filterable
                    >
                      <el-option
                        v-for="item in approve"
                        :key="item.id"
                        :label="item.nikename"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <!-- <div class="divider"></div> -->

              <el-row>
                <el-form-item label="采购单位" prop="extInfo.procureunit">
                  <el-input
                    v-model="form.extInfo.procureunit"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </el-row>
              <div class="divider"></div>

              <div class="top">
                <div class="icon"></div>
                <div>收费信息</div>
              </div>
              <el-row>
                <el-col :span="6">
                  <el-form-item label="收费方式" prop="chargingMethod">
                    <el-select
                      style="width: 100%"
                      v-model="form.chargingMethod"
                      placeholder="请选择"
                      class="select"
                    >
                      <el-option
                        v-for="item in chargestatus"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6" class="money">
                  <el-form-item label="投标价格" prop="amountOfSubject">
                    <el-input
                      v-model="form.amountOfSubject"
                      placeholder="请输入"
                      clearable
                    ></el-input>
                    <div style="margin-left: 4px">元</div>
                  </el-form-item>
                </el-col>
                <!-- <el-row>
                
                <el-col :span="14">
                  <el-form-item label="案件标的物" prop="subjectMatter ">
                    <el-input v-model="form.subjectMatter" placeholder="请输入"></el-input>
                  </el-form-item>
                </el-col>
                
                <el-col :span="10" class="money">
                  <el-form-item label="投标价格" prop="amountOfSubject">
                    <el-input v-model="form.amountOfSubject" placeholder="请输入" clearable></el-input>
                    <div style="margin-left: 4px;">元</div>
                  </el-form-item>
                </el-col>
              </el-row> -->

                <el-col :span="6">
                  <el-form-item label="简介" prop="introduction">
                    <el-input
                      v-model="form.introduction"
                      placeholder="请输入"
                      clearable
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="备注" prop="remark ">
                    <el-input
                      v-model="form.remark"
                      placeholder="请输入"
                      clearable
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="6" class="money">
                  <!-- 定额收费金额 -->
                  <el-form-item
                    label="收费金额"
                    prop="fixed"
                    v-if="form.chargingMethod == '固定收费'"
                  >
                    <el-input
                      v-model="form.fixed"
                      placeholder="请输入"
                      clearable
                    ></el-input>
                    <div style="margin-left: 4px">元</div>
                  </el-form-item>
                  <!-- 风险收费金额 -->
                  <el-form-item
                    label="收费金额"
                    prop="riskFixed"
                    v-if="form.chargingMethod == '风险收费'"
                  >
                    <el-input
                      v-model="form.riskFixed"
                      placeholder="请输入"
                      clearable
                    ></el-input>
                    <div style="margin-left: 4px">元</div>
                  </el-form-item>
                </el-col>
                <el-col
                  :span="6"
                  v-if="form.chargingMethod == '风险收费'"
                  class="money"
                >
                  <el-form-item label="风险收费比例" prop="riskRatio">
                    <el-input
                      v-model="form.riskRatio"
                      placeholder="请输入"
                      clearable
                    ></el-input>
                    <div style="margin-left: 4px">%</div>
                  </el-form-item>
                </el-col>
              </el-row>
              <!-- <el-row>
                <el-col :span="14">
                  <el-form-item label="申请用章" prop="SealType">
                    <el-select
                      style="width: 100%"
                      v-model="form.SealType"
                      placeholder="请选择"
                      class="select"
                    >
                      <el-option
                        v-for="item in seal"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row> -->
              <el-row>
                <el-col :span="8">
                  <el-form-item label="招标文件" prop="BidFile">
                    <el-upload
                      class="upload_file"
                      :show-file-list="false"
                      v-model="form.BidFile"
                      action="/api/Filer/PcUpload?flag=00000000-0000-0000-0000-000000000000&filetype=招标"
                      :before-upload="(file) => beforeUpload(file, 1)"
                      :on-change="(file) => onChange(file, 1)"
                      :on-progress="(event, file) => onProgress(event, file, 1)"
                      multiple
                      :file-list="FileList1"
                      :on-success="
                        (response, file, fileList) =>
                          uploadSuccess(response, file, fileList, 1)
                      "
                      :on-remove="(file) => handleRemove(file, 1)"
                    >
                      <el-button size="small" class="fjchoose"
                        >请选择附件</el-button
                      >
                    </el-upload>
                    <!-- 附件回显 -->
                    <div
                      v-for="(item, index) in FileList1"
                      :key="item.uid"
                      class="file_show"
                      style="margin-top: 10px"
                    >
                      <div class="fj" v-if="!item.isShow">
                        <div style="flex: 1">
                          <img
                            src="../../assets/file/word.svg"
                            v-if="item.ftype == 'doc' || item.ftype == 'docx'"
                          />
                          <img
                            src="../../assets/file/xls.svg"
                            v-if="item.ftype == 'xlsx' || item.ftype == 'xls'"
                          />
                          <img
                            src="../../assets/file/png.svg"
                            v-if="
                              item.ftype == 'jpg' ||
                              item.ftype == 'jpeg' ||
                              item.ftype == 'png'
                            "
                          />
                          <img
                            src="../../assets/file/PDF.svg"
                            v-if="item.ftype == 'pdf'"
                          />
                        </div>
                        <div class="fname" style="flex: 9">
                          <div>
                            {{ item.name }}
                          </div>
                          <div class="word">
                            <span @click="look(item)" class="look">预览</span>
                            <!-- <span class="down" @click="down(item)">下载</span> -->
                            <span @click="del(index, 1)" class="del">删除</span>
                          </div>
                        </div>
                      </div>
                      <!--文件上传进度条-->
                      <div class="uploadprocess" v-else>
                        <div>
                          <div class="jdtext">
                            <div class="uploadname">{{ item.name }}</div>
                            <div class="per">{{ item.curPercentage }}%</div>
                          </div>
                          <el-progress
                            :percentage="item.curPercentage"
                            :show-text="false"
                          ></el-progress>
                        </div>
                      </div>
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="8">
                  <el-form-item label="附件" prop="otherFile">
                    <el-upload
                      class="upload_file"
                      v-model="form.otherFile"
                      :show-file-list="false"
                      action="/api/Filer/PcUpload?flag=00000000-0000-0000-0000-000000000000&filetype=附件"
                      :before-upload="(file) => beforeUpload(file, 2)"
                      multiple
                      :file-list="FileList2"
                      :on-success="
                        (response, file, fileList) =>
                          uploadSuccess(response, file, fileList, 2)
                      "
                      :on-change="(file) => onChange(file, 2)"
                      :on-progress="(event, file) => onProgress(event, file, 2)"
                      :on-remove="(file) => handleRemove(file, 2)"
                    >
                      <el-button size="small" class="fjchoose"
                        >请选择附件</el-button
                      >
                    </el-upload>
                    <!-- 附件回显 -->
                    <div
                      v-for="(item, index) in FileList2"
                      :key="item.uid"
                      class="file_show"
                      style="margin-top: 10px"
                    >
                      <div class="fj" v-if="!item.isShow">
                        <div style="flex: 1">
                          <img
                            src="../../assets/file/word.svg"
                            v-if="item.ftype == 'doc' || item.ftype == 'docx'"
                          />
                          <img
                            src="../../assets/file/xls.svg"
                            v-if="item.ftype == 'xlsx' || item.ftype == 'xls'"
                          />
                          <img
                            src="../../assets/file/png.svg"
                            v-if="
                              item.ftype == 'jpg' ||
                              item.ftype == 'jpeg' ||
                              item.ftype == 'png'
                            "
                          />
                          <img
                            src="../../assets/file/PDF.svg"
                            v-if="item.ftype == 'pdf'"
                          />
                        </div>
                        <div class="fname" style="flex: 9">
                          <div>
                            {{ item.name }}
                          </div>
                          <div class="word">
                            <span @click="look(item)" class="look">预览</span>
                            <!-- <span class="down" @click="down(item)">下载</span> -->
                            <span @click="del(index, 2)" class="del">删除</span>
                          </div>
                        </div>
                      </div>
                      <!--文件上传进度条-->
                      <div class="uploadprocess" v-else>
                        <div>
                          <div class="jdtext">
                            <div class="uploadname">{{ item.name }}</div>
                            <div class="per">{{ item.curPercentage }}%</div>
                          </div>
                          <el-progress
                            :percentage="item.curPercentage"
                            :show-text="false"
                          ></el-progress>
                        </div>
                      </div>
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="8" v-if="form.chargingMethod == '免费'">
                  <el-form-item label="免费凭证" prop="FreeFile">
                    <el-upload
                      class="upload_file"
                      :show-file-list="false"
                      v-model="form.FreeFile"
                      action="/api/Filer/PcUpload?flag=00000000-0000-0000-0000-000000000000&filetype=免费"
                      :before-upload="(file) => beforeUpload(file, 3)"
                      :on-change="(file) => onChange(file, 3)"
                      :on-progress="(event, file) => onProgress(event, file, 3)"
                      multiple
                      :file-list="FileList3"
                      :on-success="
                        (response, file, fileList) =>
                          uploadSuccess(response, file, fileList, 3)
                      "
                      :on-remove="(file) => handleRemove(file, 3)"
                    >
                      <el-button size="small" class="fjchoose"
                        >请选择附件</el-button
                      >
                    </el-upload>
                    <!-- 附件回显 -->
                    <div
                      v-for="(item, index) in FileList3"
                      :key="item.uid"
                      class="file_show"
                      style="margin-top: 10px"
                    >
                      <div class="fj" v-if="!item.isShow">
                        <div style="flex: 1">
                          <img
                            src="../../assets/file/word.svg"
                            v-if="item.ftype == 'doc' || item.ftype == 'docx'"
                          />
                          <img
                            src="../../assets/file/xls.svg"
                            v-if="item.ftype == 'xlsx' || item.ftype == 'xls'"
                          />
                          <img
                            src="../../assets/file/png.svg"
                            v-if="
                              item.ftype == 'jpg' ||
                              item.ftype == 'jpeg' ||
                              item.ftype == 'png'
                            "
                          />
                          <img
                            src="../../assets/file/PDF.svg"
                            v-if="item.ftype == 'pdf'"
                          />
                        </div>
                        <div class="fname" style="flex: 9">
                          <div>
                            {{ item.name }}
                          </div>
                          <div class="word">
                            <span @click="look(item)" class="look">预览</span>
                            <!-- <span class="down" @click="down(item)">下载</span> -->
                            <span @click="del(index, 3)" class="del">删除</span>
                          </div>
                        </div>
                      </div>
                      <!--文件上传进度条-->
                      <div class="uploadprocess" v-else>
                        <div>
                          <div class="jdtext">
                            <div class="uploadname">{{ item.name }}</div>
                            <div class="per">{{ item.curPercentage }}%</div>
                          </div>
                          <el-progress
                            :percentage="item.curPercentage"
                            :show-text="false"
                          ></el-progress>
                        </div>
                      </div>
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>

              <!-- 收费明细 -->
              <div v-if="false">
                <div
                  v-if="
                    form.chargingMethod == '固定收费' ||
                    (form.riskFixed != 0 && form.chargingMethod == '风险收费')
                  "
                >
                  <div class="divider"></div>
                  <div class="top">
                    <div class="icon"></div>
                    <div @click="addCharge">收费明细</div>
                  </div>
                  <el-row class="addrow">
                    <i class="el-icon-plus" @click="addCharge">添加明细</i>
                  </el-row>
                  <el-row>
                    <el-table
                      class="party"
                      border
                      :data="form.bcbdTable"
                      style="width: 100%"
                      :header-cell-style="{ textAlign: 'c' }"
                      :cell-style="{ textAlign: 'center' }"
                    >
                      <!-- <el-table-column label="款项名称" prop="name">
                      <template slot-scope="scope">
                          <el-input v-model="scope.row.name" placeholder="请输入" ></el-input>
                      </template>
                    </el-table-column> -->
                      <el-table-column
                        label="款项名称"
                        prop="Name"
                        :render-header="addRedStar"
                      >
                        <template slot-scope="scope">
                          <el-form-item
                            :prop="'bcbdTable.' + scope.$index + '.Name'"
                            :rules="{
                              required: true,
                              message: '不能为空',
                              trigger: 'blur'
                            }"
                            label-width="0"
                          >
                            <el-input
                              v-model="scope.row.Name"
                              placeholder="请输入"
                              clearable
                            ></el-input>
                          </el-form-item>
                        </template>
                      </el-table-column>
                      <el-table-column
                        label="应收金额"
                        prop="Amount"
                        :render-header="addRedStar"
                      >
                        <template slot-scope="scope">
                          <el-form-item
                            :prop="'bcbdTable.' + scope.$index + '.Amount'"
                            :rules="{ validator: Price, trigger: 'change' }"
                            label-width="0"
                          >
                            <el-input
                              v-model="scope.row.Amount"
                              placeholder="请输入"
                              clearable
                            ></el-input>
                          </el-form-item>
                        </template>
                      </el-table-column>
                      <el-table-column label="约定收款日期" prop="PaymentDate">
                        <template slot-scope="scope">
                          <el-form-item
                            :prop="'bcbdTable.' + scope.$index + '.PaymentDate'"
                            label-width="0"
                          >
                            <el-date-picker
                              style="width: 100%"
                              v-model="scope.row.PaymentDate"
                              value-format="yyyy-MM-dd"
                              type="date"
                              placeholder="请选择日期"
                              :clearable="false"
                            >
                            </el-date-picker>
                          </el-form-item>
                        </template>
                      </el-table-column>

                      <el-table-column label="备注" prop="Remark">
                        <template slot-scope="scope">
                          <el-form-item
                            :prop="'bcbdTable.' + scope.$index + '.Remark'"
                            label-width="0"
                          >
                            <el-input
                              v-model="scope.row.Remark"
                              placeholder="请输入"
                            ></el-input>
                          </el-form-item>
                        </template>
                      </el-table-column>
                      <el-table-column
                        label="状态"
                        prop="Status"
                        :render-header="addRedStar"
                      >
                        <template slot-scope="scope">
                          <el-form-item
                            :prop="'bcbdTable.' + scope.$index + '.Status'"
                            label-width="0"
                            :rules="{
                              required: true,
                              message: '不能为空 ',
                              trigger: 'change'
                            }"
                          >
                            <el-select
                              style="width: 100%"
                              v-model="scope.row.Status"
                              placeholder="请选择"
                            >
                              <el-option
                                v-for="item in Bcbd_status"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                              >
                              </el-option>
                            </el-select>
                          </el-form-item>
                        </template>
                      </el-table-column>
                      <el-table-column label="操作">
                        <template slot-scope="scope">
                          <span class="copy" @click="copy(scope.row)"
                            >复制</span
                          >
                          <span
                            class="bgdel"
                            v-if="form.bcbdTable.length > 1"
                            @click="reduceCharge(scope.$index)"
                            >删除</span
                          >
                        </template>
                      </el-table-column>
                    </el-table>
                  </el-row>
                </div>
              </div>
              <!-- 用章申请 -->
              <div class="divider"></div>
              <div class="top">
                <div class="icon"></div>
                <div>用章申请</div>
              </div>

              <el-row>
                <el-col :span="24">
                  <el-form
                    class="form"
                    ref="ruleformseal"
                    :model="form.dialogform"
                    :rules="ruleseal"
                    label-width="134px"
                  >
                    <el-col :span="12">
                      <el-form-item label="申请人" prop="applicant">
                        <el-select
                          v-model="form.dialogform.applicant"
                          placeholder="请选择"
                          style="width: 100%"
                          filterable
                          @change="SealChange()"
                        >
                          <el-option
                            v-for="item in Lawyer"
                            :key="item.id"
                            :label="item.nikename"
                            :value="item.id"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <!-- <el-form-item label="二次审批人" prop="approver">
                      <el-select
                        v-model="form.dialogform.approver"
                        style="width: 100%"
                        placeholder="请选择"
                        class="select"
                        clearable
                        filterable
                      >
                        <el-option
                          v-for="item in Sealapprove"
                          :key="item.id"
                          :label="item.nikename"
                          :value="item.id"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item> -->
                    <el-col :span="12">
                      <el-form-item label="用章事由" prop="reason">
                        <el-input
                          placeholder="请输入"
                          v-model="form.dialogform.reason"
                          disabled
                        ></el-input>
                      </el-form-item>
                    </el-col>

                    <!-- <el-form-item label="部门主管" prop="SealLeaders">
                      <el-select
                        style="width: 100%"
                        v-model="form.dialogform.SealLeaders"
                        placeholder="请选择"
                        class="select"
                        clearable
                        filterable
                      >
                        <el-option
                          v-for="item in SealdepLeaders"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item> -->
                    <el-form-item v-show="false" label="附件" prop="file">
                      <el-select
                        v-model="form.dialogform.file"
                        placeholder="请选择"
                        class="input"
                        style="width: 100%"
                        multiple
                        filterable
                      >
                        <el-option
                          v-for="item in FileList"
                          :key="item.uid"
                          :label="item.name"
                          :value="item.uid"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-form>
                </el-col>
                <el-col v-show="false" :span="14">
                  <div style="margin-left: 20px">
                    <div>支持导出的材料：</div>
                    <div style="display: flex">
                      <div>
                        <el-checkbox-group
                          v-model="form.dialogform.checkedCities"
                          @change="handleCheckedCitiesChange"
                        >
                          <el-checkbox
                            style="display: block; padding-top: 20px"
                            v-for="city in form.dialogform.cities"
                            :label="city.name"
                            :key="city.name"
                            >{{ city.name }}</el-checkbox
                          >
                        </el-checkbox-group>
                      </div>
                      <div>
                        <div
                          style="margin-left: 20%; padding-top: 12px"
                          v-for="city in form.dialogform.cities"
                        >
                          <el-select
                            size="mini"
                            v-model="city.stype"
                            placeholder="请选择用章类型"
                            class="yz_input"
                            @change="GetSealLevel()"
                            clearable
                            filterable
                            multiple
                          >
                            <el-option
                              v-for="item in seal"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value"
                            >
                            </el-option>
                          </el-select>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div></div>
                </el-col>
              </el-row>
            </el-form>
            <div class="allbtn">
              <el-button type="warning" @click="saveCaoGao()">
                保存草稿
              </el-button>
              <!-- <el-button type="warning" @click="updateCaoGao()">
                修改草稿
              </el-button> -->
              <el-button
                type="primary"
                @click="Post('ruleForm')"
                :disabled="dianji"
                >确认新增</el-button
              >
              <!-- <el-button type="warning" @click="Save">保存草稿</el-button> -->
              <el-button class="history" @click="history">返回</el-button>
            </div>
          </div>
        </div>
      </el-card>
    </div>
    <el-dialog title="用章申请" center :visible.sync="applyDialog" width="40%">
      <el-form
        class="form"
        label-width="120px"
        :model="form.dialogform"
        :rules="ruleseal"
        ref="ruleformseal"
      >
        <!-- <el-form-item label="申请人" prop="applicant">
          <el-select
            v-model="dialogform.applicant"
            placeholder="请选择"
            style="width: 50%"
            filterable
            @change="SealChange()"
          >
            <el-option
              v-for="item in Lawyer"
              :key="item.id"
              :label="item.nikename"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="用章类型" prop="SealType">
          <el-select
            v-model="dialogform.SealType"
            placeholder="请选择"
            style="width: 50%"
            disabled
          >
            <el-option
              v-for="item in seal"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="部门审批人" prop="SealLeaders">
          <el-select
            v-model="dialogform.SealLeaders"
            placeholder="请先选择申请人"
            style="width: 50%"
            clearable
            filterable
          >
            <el-option
              v-for="item in SealdepLeaders"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="二次审批人" prop="approver">
          <el-select
            v-model="dialogform.approver"
            placeholder="请先选择申请人"
            style="width: 50%"
            filterable
          >
            <el-option
              v-for="item in Sealapprove"
              :key="item.id"
              :label="item.nikename"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="用章事由" prop="reason">
          <el-input
            placeholder="请输入"
            v-model="dialogform.reason"
            type="text"
            style="width: 50%"
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item label="附件" prop="file">
          <el-select
            v-model="dialogform.file"
            placeholder="请选择"
            style="width: 50%"
            multiple
            filterable
            onchange
          >
            <el-option
              v-for="(item, index) in FileList"
              :key="index"
              :label="item.name"
              :value="item.uid"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item style="text-align: center" label-width="0">
          <el-button @click="addEnter('ruleformseal')" type="primary"
            >确认</el-button
          >
        </el-form-item> -->
      </el-form>
    </el-dialog>
    <!-- 预览dialog -->
    <el-dialog
      center
      title="文件预览"
      :visible.sync="dialogVisible"
      append-to-body
      class="file-dialog"
      width="70%"
      @close="close"
    >
      <div v-if="isImage">
        <iframe
          id="printIframe"
          :src="imgUrl"
          frameborder="0"
          style="width: 100%; height: 600px"
        />
      </div>
      <!-- word -->
      <!-- //图片不会过大的写法但是有空白 要引入docx-preview-->
      <!-- <div v-if="isWord" ref="word"  style="width: 100%"></div> -->
      <!-- //图片过大，无空白 -->
      <div v-if="isWord" v-html="vHtml" style="width: 100%"></div>
      <!-- excel -->
      <div v-if="isExcel">
        <el-table
          :data="excelData"
          border
          stripe
          :header-cell-style="{ background: '#F5F4F7' }"
        >
          <el-table-column
            type="index"
            label="序号"
            width="60"
            :resizable="false"
            align="center"
          />
          <el-table-column
            v-for="(value, key, index) in excelData[0]"
            :key="index"
            :prop="key"
            :label="key"
          />
        </el-table>
      </div>
    </el-dialog>

    <!-- 草稿 -->
    <el-dialog
      title="提示"
      :visible.sync="centerDialogVisible"
      width="30%"
      center
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <div style="text-align: center">
        检测到当前案件类型有草稿存在，是否基于草稿继续录入？
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="caoGaoInput()">基于草稿录入</el-button>
        <el-button type="primary" @click="inputDraftNew()">全新录入</el-button>
        <el-button type="danger" @click="deleteCaoGao()"
          >管理当前案件类型草稿</el-button
        >
        <!-- <el-button type="warning" @click="newInput()"
          >全新录入（清除草稿）</el-button
        > -->
      </span>
    </el-dialog>

    <!-- 草稿选择 -->
    <el-dialog
      title="请选择草稿"
      :visible.sync="cgDialogVisible"
      width="30%"
      center
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <div style="text-align: center">
        <el-select
          v-model="cgid"
          class="all-select"
          clearable
          placeholder="请选择"
        >
          <el-option
            v-for="item in caoGao"
            :key="item.uuid"
            :label="item.title"
            :value="item.uuid"
          />
        </el-select>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cgDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="cgInput(cgid)">确 认</el-button>
        <!-- <el-button type="warning" @click="newInput()"
          >全新录入（清除草稿）</el-button
        > -->
      </span>
    </el-dialog>
    <!-- 草稿管理 -->
    <el-dialog
      title="请选择草稿"
      :visible.sync="scDialogVisible"
      width="30%"
      center
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <div style="text-align: center">
        <el-select
          v-model="scid"
          class="all-select"
          clearable
          placeholder="请选择您要删除的草稿"
          multiple
        >
          <el-option
            v-for="item in caoGao"
            :key="item.uuid"
            :label="item.title"
            :value="item.uuid"
          />
        </el-select>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="scDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="scCG(scid)">删 除</el-button>
        <!-- <el-button type="warning" @click="newInput()"
          >全新录入（清除草稿）</el-button
        > -->
      </span>
    </el-dialog>
    <!-- 加载中组件 -->
    <loading-overlay v-if="isLoading"></loading-overlay>
  </div>
</template>
    
<script>
import { BidAdd, GetDepartmentLeaders } from '../../api/bankrupt'
import { user } from '../../api/seal'
import { requestDownLoadFile, requestReview } from '../../api/counsel.js'
import mammoth from 'mammoth'
// 定义blob对应的type
const fileTypeMap = {
  xls: 'application/vnd.ms-excel',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  doc: 'application/msword',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  pdf: 'application/pdf',
  ppt: 'application/pdf',
  pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  png: 'image/png',
  gif: 'image/gif',
  jpeg: 'image/jpeg',
  jpg: 'image/jpeg',
  txt: 'text/plain'
}
const docx = require('docx-preview')
const XLSX = require('xlsx')
export default {
  name: 'bankinput',

  data() {
    var Price = (rule, value, callback) => {
      var price = /^\d+(\.\d{0,2})?$/
      if (!value) {
        callback(new Error('不能为空'))
      } else if (value <= 0) {
        callback(new Error('请输入大于0的金额'))
      } else if (!price.test(value)) {
        callback(new Error('请输入正确格式的金额')) //防止输入多个小数点
      } else {
        callback()
      }
    }
    var NewPrice = (rule, value, callback) => {
      var price = /^\d+(\.\d{0,2})?$/
      if (!price.test(value)) {
        callback(new Error('请输入正确格式的金额')) //防止输入多个小数点
      } else {
        callback()
      }
    }

    var riskRatio = (rule, value, callback) => {
      var price = /^\d+(\.\d{0,2})?$/
      if (!value) {
        callback(new Error('不能为空'))
      } else if (value < 0) {
        callback(new Error('请输入大于0的金额'))
      } else if (value > 100) {
        callback(new Error('不能大于100'))
      } else if (!price.test(value)) {
        callback(new Error('最多输入两位小数')) //防止输入多个小数点
      } else {
        callback()
      }
    }
    var debtor = (rule, value, callback) => {
      var price = /^\d+(\.\d{0,2})?$/
      if (value && value <= 0) {
        callback(new Error('请输入大于0的金额'))
      } else if (value && !price.test(value)) {
        callback(new Error('请输入正确格式的金额')) //防止输入多个小数点
      } else {
        callback()
      }
    }
    return {
      ruleseal: {
        applicant: { required: true, message: '不能为空 ', trigger: 'change' },
        approver: { required: true, message: '不能为空 ', trigger: 'change' },
        SealType: { required: true, message: '不能为空 ', trigger: 'change' },
        reason: { required: true, message: '不能为空 ', trigger: 'change' },
        file: { required: true, message: '不能为空 ', trigger: 'change' },
        SealLeaders: { required: true, message: '不能为空 ', trigger: 'change' }
      },
      isLoading: false,
      numType: 'CaseBid',
      CaogaoCode: null,
      isShowJinDuTiao: false, //上传进度招标文件
      isShowother: false, //上传进度普通文件
      curPercentage: 0, //进度百分比
      uploadname: '', //正在上传的文件名称
      next: true, //是否是三级页面
      form: {
        title: '', //名称
        cause: '', //概要
        code: '', //编号
        casestatus: '受理', //案卷状态
        // partner:"",//项目合伙人
        // draft:"",//底稿资料
        departmentLeaders: '', //部门审批人
        approve: '', //二次审批人
        // postTime:null,//立项时间
        source: '', //项目来源
        acceptUnit: '', //代理机构
        acceptCode: '', //受理机构
        LeadLawyer: [], //服务律师
        CoCounsel: [], //服务律师
        BidFile: [], //招标文件
        FreeFile: [], //免费凭证
        otherFile: [], //附件
        SealType: '', //合同用章
        //收费
        chargingMethod: '固定收费', //收费方式
        amountOfSubject: '', //投标价格，默认为0
        introduction: '', //简介
        remark: '', //备注
        fixed: null, //定额收费金额
        riskFixed: 0, //半风险中的定额收费金额
        riskRatio: 0, //风险收费比例
        bcbdTable: [
          // 收费明细
          {
            Name: '',
            Amount: null,
            PaymentDate: null,
            Remark: '',
            Status: null
          }
        ],
        extInfo: {
          //扩展字段
          partner: '', //合伙人
          draft: '', //底稿资料
          projecttype: '', //项目类型
          opentime: null, //开放时间
          procuremethod: '', //采购方式
          budgetmoney: '', //预算金额
          procurecode: '', //采购编号
          procureunit: '' //采购单位
        },
        dialogform: {
          //用章
          applicant: '',
          approver: '',
          file: [],
          reason: '申请立项',
          SealType: '',
          SealLeaders: '', //部门审批人
          checkedCities: [],
          cities: null
        },

        draftFormId: null,
        draftFormType: null,
        uuid: null
      },
      rules: {
        chargingMethod: {
          required: true,
          message: '不能为空 ',
          trigger: 'change'
        },
        postTime: { required: true, message: '不能为空 ', trigger: 'change' },
        title: { required: true, message: '不能为空 ', trigger: 'change' },
        cause: { required: true, message: '不能为空 ', trigger: 'change' },
        approve: { required: true, message: '不能为空 ', trigger: 'change' },
        LeadLawyer: { required: true, message: '不能为空 ', trigger: 'change' }, //服务律师
        casestatus: { required: true, message: '不能为空 ', trigger: 'change' },
        SealType: { required: true, message: '不能为空 ', trigger: 'change' },
        // amountOfSubject: [{ validator: NewPrice, trigger: 'change' }], //投标价格
        fixed: [
          { required: true, message: '不能为空 ', trigger: 'change' },
          { validator: Price, trigger: 'change' }
        ], //定额收费金额
        riskFixed: [{ validator: NewPrice, trigger: 'change' }], //半风险中的定额收费金额
        riskRatio: [{ required: true, validator: NewPrice, trigger: 'change' }, { validator: riskRatio, trigger: 'change' }], //风险收费比例
        BidFile: { required: true, message: '不能为空 ', trigger: 'change' },
        FreeFile: { required: true, message: '不能为空 ', trigger: 'change' },
        extInfo: { budgetmoney: [{ validator: debtor, trigger: 'change' }] },
        // acceptCode:{ required: true, message: '不能为空 ', trigger: 'change'},
        acceptUnit: { required: true, message: '不能为空 ', trigger: 'change' },
        departmentLeaders: {
          required: true,
          message: '不能为空 ',
          trigger: 'change'
        }
      },

      ProjectType: [
        { label: '政府采购', value: 0 },
        { label: '国企采购', value: 1 },
        { label: '其他社会采购', value: 2 }
      ], //项目类型
      Date: [
        { value: '1', label: '一月之内' },
        { value: '2', label: '二月之内' },
        { value: '3', label: '三月之内' }
      ],
      Bcbd_status: [
        { value: 0, label: '已完成' },
        // { value: 1, label: '已禁用' },
        { value: 2, label: '已提醒' },
        { value: 3, label: '待提醒' }
        // { value: -1, label: '已删除' },
      ],
      CaseStatus: [
        { label: '受理', value: '受理' },
        { label: '未受理', value: '未受理' }
      ], //案卷状态
      Draft: [
        { label: '已归档', value: true },
        { label: '未归档', value: false }
      ], //底稿资料
      approve: [], //二次审批人
      depLeaders: [], //部门领导人
      SealdepLeaders: [], //用章申请部门领导人
      Sealapprove: [], //用章二次审批人
      Lawyer: [], //代理律师
      selectedLawyer: [], //被选择的律师
      chargestatus: [
        { value: '免费', label: '免费' },
        { value: '固定收费', label: '固定收费' },
        { value: '风险收费', label: '风险收费' }
      ], //收费情况
      seal: [
        { label: '合同章', value: 'contract_seal' },
        { label: '法人章', value: 'corporate_seal' },
        { label: '公章', value: 'official_seal' }
        // { label: '公章+法人章', value: 'official_corporate_seal' },
        // { label: '合同章+法人章', value: 'contract_corporate_seal' },
        // { label: '法律意见书专用章', value: 'law_seal' },
        // { label: '律师函专用章', value: 'legal_letter_seal' }
      ], //合同用章
      FileList1: [], //招标文件
      FileList2: [], //普通文件
      FileList3: [], //免费凭证
      applyDialog: false, //申请用章弹出框
      FileList: [], //申请用章附件

      imgUrl: '', //图片路径
      sheetNames: null, //从数据中获取到的sheet页数组
      dialogVisible: false,
      imgType: ['jpg', 'jpeg', 'png', 'pdf'],
      excelHtml: '',
      excelData: null,
      vHtml: null,
      isExcel: false,
      isWord: false,
      isImage: false,
      times: 1, //回退次数
      centerDialogVisible: false,
      cgDialogVisible: false,
      caoGao1: false,
      newcaoGao1: false,
      caoGao: [],
      cgid: null,
      my: false,
      scDialogVisible: false,
      scid: null,
      dianji: false
    }
  },

  methods: {
    handleCheckedCitiesChange() {
      // console.log(this.form.dialogform.checkedCities)
    },
    user(id) {
      user({}).then((res) => {
        if (res.data.status == 'success') {
          this.Lawyer = res.data.data.filter((item) => item.status == 0||item.status==6)
          if (this.Lawyer.length > 0) {
            if (id) {
              this.form.dialogform.applicant = id[0]
            } else {
              this.form.LeadLawyer.push(this.Lawyer[0].uid)
              this.form.dialogform.applicant = this.Lawyer[0].uid
              this.SealChange()
            }

            this.selectChange('1')
          }
        } else if (
          res.data.status == '401' ||
          res.data.status == '402' ||
          res.data.status == '403'
        ) {
          this.$message.error(res.data.message)
          window.sessionStorage.removeItem('token')
          window.sessionStorage.removeItem('hasRoles')
          this.$router.push('/login')
        }
      })
    },
    GetApprove() {
      //获取案件二次审核人
      user({
        Id: this.form.LeadLawyer[0],
        apporver: 'case_00000000-0012-0012-0013-000000000000'
      }).then((res) => {
        if (res.data.status == 'success') {
          this.approve = res.data.data
          var index = this.approve.findIndex((item) => {
            return item.id == this.form.approve
          })
          if (index == -1) {
            //不存在，清空二次审批人
            this.form.approve = ''
          }
        } else if (
          res.data.status == '401' ||
          res.data.status == '402' ||
          res.data.status == '403'
        ) {
          this.$message.error(res.data.message)
          window.sessionStorage.removeItem('token')
          window.sessionStorage.removeItem('hasRoles')
          this.$router.push('/login')
        }
      })
    },
    GetSealApprove() {
      //获取用章二次审核人
      var newSeal = []
      // console.log(this.form.dialogform.cities)
      this.form.dialogform.cities.forEach((value) => {
        if (value.stype.length > 0) {
          newSeal.push(value.stype.join(','))
        }
      })
      var uniqueArr = [
        ...new Map(newSeal.map((item) => [item, item])).values()
      ].join(',')
      user({
        Id: this.form.dialogform.applicant,
        apporver: uniqueArr
      }).then((res) => {
        if (res.data.status == 'success') {
          this.Sealapprove = res.data.data
          var index = this.Sealapprove.findIndex((item) => {
            return item.id == this.form.dialogform.approver
          })
          if (index == -1) {
            //不存在，清空二次审批人
            this.form.dialogform.approver = ''
          }
        } else if (
          res.data.status == '401' ||
          res.data.status == '402' ||
          res.data.status == '403'
        ) {
          this.$message.error(res.data.message)
          window.sessionStorage.removeItem('token')
          window.sessionStorage.removeItem('hasRoles')
          this.$router.push('/login')
        }
      })
    },
    GetDepartmentLeaders(id, type) {
      //获取部门审批人
      GetDepartmentLeaders({ Id: id }).then((res) => {
        if (res.data.status == 0) {
          if (type == 'seal') {
            //用章的部门审批人
            this.SealdepLeaders = res.data.data
            var index = this.SealdepLeaders.findIndex((item) => {
              return item.value == this.form.dialogform.SealLeaders
            })
            if (index == -1) {
              //不存在，清空
              this.form.dialogform.SealLeaders = ''
            }
          }
          if (type == 'case') {
            //案件的部门审批人
            this.depLeaders = res.data.data
            var index = this.depLeaders.findIndex((item) => {
              return item.value == this.form.departmentLeaders
            })
            if (index == -1) {
              //不存在，清空二次审批人
              this.form.departmentLeaders = ''
            }
          }
        } else if (
          res.data.status == '401' ||
          res.data.status == '402' ||
          res.data.status == '403'
        ) {
          this.$message.error(res.data.message)
          window.sessionStorage.removeItem('token')
          window.sessionStorage.removeItem('hasRoles')
          this.$router.push('/login')
        } else {
          if (type == 'seal') {
            //用章的部门审批人
            this.SealdepLeaders = []
            this.form.dialogform.SealLeaders = ''
          }
          if (type == 'case') {
            this.depLeaders = []
            this.form.departmentLeaders = ''
          }
          this.$message.error(res.data.message)
        }
      })
    },
    SealChange() {
      this.GetSealApprove()
      this.GetDepartmentLeaders(this.form.dialogform.applicant, 'seal')
    },
    //添加收费明细
    addCharge() {
      // console.log("添加")
      this.form.bcbdTable.push({
        Name: '',
        Amount: null,
        PaymentDate: null,
        Remark: '',
        Status: null
      })
    },
    // 减少收费明细
    reduceCharge(index) {
      this.form.bcbdTable.splice(index, 1)
    },
    copy(row) {
      this.form.bcbdTable.push({
        Name: row.Name,
        Amount: row.Amount,
        PaymentDate: row.PaymentDate,
        Remark: row.Remark,
        Status: row.Status
      })
    },
    checkInput(e) {
      let key = e.key
      if (key === 'e' || key === 'E' || key === '+' || key === '-') {
        e.returnValue = false
        return false
      }
      return true
    },
    history() {
      this.$router.go(-this.times)
    },
    close() {
      if (this.imgUrl) {
        this.times = this.times + 1
        this.imgUrl = ''
      }
    },
    handlerError(data) {
      let enc = new TextDecoder('utf-8')
      var res = enc.decode(new Uint8Array(data))
      var jsonData = JSON.parse(res)
      //  console.log(jsonData)
      //  console.log(jsonData.status)
      if (
        jsonData.status == '401' ||
        jsonData.status == '402' ||
        jsonData.status == '403'
      ) {
        this.$message.error(jsonData.message)
        window.sessionStorage.removeItem('token')
        window.sessionStorage.removeItem('hasRoles')
        this.$router.push('/login')
      }
      // this.$message.error(enc.decode(new Uint8Array(res.data)))
    },
    // 预览文件
    look(item) {
      let fileType = item.ftype
      this.isLoading = true
      this.dianji = true
      // 后台接口方法url：接口地址，data给后台传的参数
      let type = ''
      if (fileType) {
        type = fileTypeMap[fileType]
        if (this.imgType.includes(fileType)) {
          this.dialogVisible = true
          this.isWord = false
          this.isExcel = false
          this.isImage = true
          //Image PDF
          requestDownLoadFile({ Id: item.uid }).then((res) => {
            if (res.data.type && res.data.type.includes('application/json')) {
              this.handlerResponseError(res.data)
            } else {
              const blob = new Blob([res.data], { type })
              this.imgUrl = this.getObjectURL(blob)
            }
          })
          // } else if (fileType === 'doc' || fileType === 'docx') {
        } else if (fileType === 'docx') {
          this.dialogVisible = true
          var vm = this
          //WORD
          this.isWord = true
          this.isExcel = false
          this.isImage = false
          requestReview({ Id: item.uid }).then((res) => {
            // docx.renderAsync(data, this.$refs.word) // 渲染到页面预览

            if (
              res.headers['content-type'] &&
              res.headers['content-type'].includes('application/json')
            ) {
              this.handlerError(res.data)
            } else {
              mammoth
                .convertToHtml({ arrayBuffer: new Uint8Array(res.data) })
                .then(function (resultObject) {
                  vm.$nextTick(() => {
                    // document.querySelector("#wordView").innerHTML =
                    //   resultObject.value;
                    vm.vHtml = resultObject.value
                  })
                })
            }
          })
        } else if (fileType === 'xls' || fileType === 'xlsx') {
          this.dialogVisible = true
          //EXCEL
          requestReview({ Id: item.uid }).then((res) => {
            if (
              res.headers['content-type'] &&
              res.headers['content-type'].includes('application/json')
            ) {
              this.handlerError(res.data)
            } else {
              this.isExcel = true
              this.isWord = false
              this.isImage = false
              const workbook = XLSX.read(new Uint8Array(res.data), {
                type: 'array'
              }) // 解析数据
              var worksheet = workbook.Sheets[workbook.SheetNames[0]] // workbook.SheetNames 下存的是该文件每个工作表名字,这里取出第一个工作表
              // this.excelHtml = XLSX.utils.sheet_to_html(worksheet) // 渲染成html
              const sheet2JSONOpts = {
                /** Default value for null/undefined values */
                defval: '' // 给defval赋值为空的字符串,不然没值的这列就不显示
              }
              // 渲染成json
              this.excelData = XLSX.utils.sheet_to_json(
                worksheet,
                sheet2JSONOpts
              )
            }
          })
        } else {
          this.$message.error('不支持此文件预览')
        }
        this.isLoading = false
        this.dianji = false
      } else {
        this.isLoading = false
        this.dianji = false
        this.$message.error('不支持此文件预览')
      }
    },
    getObjectURL(file) {
      let url = null
      if (window.createObjectURL !== undefined) {
        // basic
        url = window.createObjectURL(file)
      } else if (window.webkitURL !== undefined) {
        // webkit or chrome
        try {
          url = window.URL.createObjectURL(file)
        } catch (error) {
          console.log(error)
        }
      } else if (window.URL !== undefined) {
        // mozilla(firefox)
        try {
          url = window.URL.createObjectURL(file)
        } catch (error) {
          console.log(error)
        }
      }
      return url
    },
    async down(item) {
      //下载
      this.isLoading = true
      this.dianji = true
      const res = await requestDownLoadFile({
        Id: item.uid
      })
      if (res.data.type && res.data.type.includes('application/json')) {
        this.handlerResponseError(res.data)
      } else {
        this.getDownLoadFile(res.data, res['headers']['content-type'], item)
      }
    },
    handlerResponseError(data) {
      const _this = this
      const fileReader = new FileReader()
      fileReader.onload = function () {
        try {
          const jsonData = JSON.parse(fileReader.result) // 说明是普通对象数据，后台转换失败
          if (
            jsonData.status == '401' ||
            jsonData.status == '402' ||
            jsonData.status == '403'
          ) {
            _this.$message.error(jsonData.message)
            window.sessionStorage.removeItem('token')
            window.sessionStorage.removeItem('hasRoles')
            _this.$router.push('/login')
          }
          // dosomething……
        } catch (err) {
          // 解析成对象失败，说明是正常的文件流
          console.log('success...')
        }
      }
      this.isLoading = false
      this.dianji = false
      fileReader.readAsText(data)
    },

    getDownLoadFile(blobFile, contenttype, row) {
      let downloadBolb = null
      let fileType = row.ftype
      // 后台接口方法url：接口地址，data给后台传的参数
      let type = ''
      if (fileType) {
        type = fileTypeMap[fileType]
        downloadBolb = new Blob([blobFile], {
          type: type
        })
        // 下载文件
        this.downloadFile(downloadBolb, row.name + '.' + fileType)
        this.isLoading = false
        this.dianji = false
        return downloadBolb
      }
    },
    downloadFile(blob, fileName) {
      let eleLink = document.createElement('a')
      eleLink.download = fileName
      eleLink.style.display = 'none'
      // 字符内容转变成blob地址
      eleLink.href = this.getObjectURL(blob)
      // 自动触发点击
      document.body.appendChild(eleLink)
      eleLink.click()
      // 然后移除
      document.body.removeChild(eleLink)
    },

    del(index, type, uid) {
      if (type == 1) {
        this.FileList1.splice(index, 1)
      } else if (type == 2) {
        this.FileList2.splice(index, 1)
      } else if (type == 3) {
        this.FileList3.splice(index, 1)
      }
      this.FileList = this.FileList1.concat(this.FileList2)
      this.form.dialogform.file = []
    },

    handleRemove(file, type) {
      //删除附件
      if (type == 1) {
        this.FileList1.forEach((value, index, array) => {
          //删除上传失败的文件
          // console.log(file.uid)
          if (value.uid == file.uid) {
            array.splice(index, 1)
          }
        })
      } else if (type == 2) {
        this.FileList2.forEach((value, index, array) => {
          //删除上传失败的文件
          // console.log(file.uid)
          if (value.uid == file.uid) {
            array.splice(index, 1)
          }
        })
      } else if (type == 3) {
        this.FileList3.forEach((value, index, array) => {
          //删除上传失败的文件
          // console.log(file.uid)
          if (value.uid == file.uid) {
            array.splice(index, 1)
          }
        })
      }
      this.FileList = this.FileList1.concat(this.FileList2)
    },
    // handlePreview(file) {
    //   console.log(file);
    // },
    // handleExceed(files, fileList) {
    //   this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    // },
    // beforeRemove(file, fileList) {//删除触发
    //   return this.$confirm(`确定移除 ${ file.name }？`);
    // },
    onProgress(event, file, type) {
      let num = ((event.loaded / event.total) * 100) | 0 //百分比
      if (type == 1) {
        this.FileList1.forEach((value) => {
          if (value.uid == file.uid) {
            value.curPercentage = num
          }
        })
      } else if (type == 2) {
        this.FileList2.forEach((value) => {
          if (value.uid == file.uid) {
            value.curPercentage = num
          }
        })
      } else if (type == 3) {
        this.FileList3.forEach((value) => {
          if (value.uid == file.uid) {
            value.curPercentage = num
          }
        })
      }
      this.FileList = this.FileList1.concat(this.FileList2)
    },
    onChange(file, type) {
      if (file.status == 'fail') {
        if (type == 1) {
          this.FileList1.forEach((value, index, array) => {
            //删除上传失败的文件

            if (value.uid == file.uid) {
              array.splice(index, 1)
            }
          })
        } else if (type == 2) {
          this.FileList2.forEach((value, index, array) => {
            //删除上传失败的文件
            // console.log(file.uid)
            if (value.uid == file.uid) {
              array.splice(index, 1)
            }
          })
        } else if (type == 3) {
          this.FileList3.forEach((value, index, array) => {
            //删除上传失败的文件3
            if (value.uid == file.uid) {
              array.splice(index, 1)
            }
          })
        }
        this.FileList = this.FileList1.concat(this.FileList2)
        return this.$message.error(file.name + '上传失败')
      }
    },
    beforeUpload(file, type) {
      //上传验证
      var filename = file.name.substring(0, file.name.lastIndexOf('.'))
      var typefile = file.name
        .substring(file.name.lastIndexOf('.') + 1)
        .toLowerCase()
      if (type == 1) {
        this.FileList1.push({
          uid: file.uid,
          name: filename,
          ftype: typefile,
          isShow: true,
          curPercentage: 0
        }) //添加上传的文件
      } else if (type == 2) {
        this.FileList2.push({
          uid: file.uid,
          name: filename,
          ftype: typefile,
          isShow: true,
          curPercentage: 0
        }) //添加上传的文件
      } else if (type == 3) {
        this.FileList3.push({
          uid: file.uid,
          name: filename,
          ftype: typefile,
          isShow: true,
          curPercentage: 0
        }) //添加上传的文件
      }
      this.FileList = this.FileList1.concat(this.FileList2)
      this.uploadname = file.name
      const isImg =
        '.jpg,.jpeg,.png,.doc,.docx,.xls,.xlsx,.pdf,.wps,.WPS'.indexOf(
          typefile
        ) >= 0
      const isMaxSize = file.size / 1024 / 1024 < 50
      if (!isImg) {
        this.$message.error(
          '只能上传jpg,jpeg,png,doc,docx,xls,xlsx,pdf格式的文件'
        )
      }
      if (!isMaxSize) {
        this.$message.error('上传大小不能超过50MB！')
      }
      return isImg && isMaxSize
    },
    uploadSuccess(res, file, fileList, type) {
      //招标文件上传成功
      // var fileid = this.FileList1.map(item => Object.assign({}, { 'id': item.id }));
      if (res.status == '0') {
        if (type == 1) {
          this.FileList1.forEach((value) => {
            //uid要改成guid,isshow变成false
            if (value.uid == file.uid) {
              value.isShow = false
              value.uid = file.response.data.substring(
                file.response.data.lastIndexOf('=') + 1
              )
            }
          })
        } else if (type == 2) {
          this.FileList2.forEach((value) => {
            //uid要改成guid,isshow变成false
            if (value.uid == file.uid) {
              value.isShow = false
              value.uid = file.response.data.substring(
                file.response.data.lastIndexOf('=') + 1
              )
            }
          })
        } else if (type == 3) {
          this.FileList3.forEach((value) => {
            //uid要改成guid,isshow变成false
            if (value.uid == file.uid) {
              value.isShow = false
              value.uid = file.response.data.substring(
                file.response.data.lastIndexOf('=') + 1
              )
            }
          })
        }
        this.FileList = this.FileList1.concat(this.FileList2)
      } else if (
        res.status == '401' ||
        res.status == '402' ||
        res.status == '403'
      ) {
        this.$message.error(res.message)
        window.sessionStorage.removeItem('token')
        window.sessionStorage.removeItem('hasRoles')
        this.$router.push('/login')
      } else {
        this.handleRemove(file, type)
        return this.$message.error(file.name + '上传失败')
      }
    },

    selectChange(type) {
      if (type == '1' && this.form.LeadLawyer.length == 1) {
        this.GetApprove()
        this.GetDepartmentLeaders(this.form.LeadLawyer[0], 'case')
      }
      this.selectedLawyer = this.form.LeadLawyer.concat(this.form.CoCounsel)
    },
    computeDifferenceSet(currentSelectValue) {
      //计算每个下拉菜单的可以选中的选项
      let remainingOption = this.Lawyer.filter((item) => {
        return (
          this.selectedLawyer.indexOf(item.id) == -1 ||
          currentSelectValue.indexOf(item.id) != -1
        )
      })
      return remainingOption
    },
    //立项日期
    onMouseOver() {
      if (this.form.postTime != undefined && this.form.postTime != null) {
        this.$refs.iconDate.style.display = 'none'
      }
    },
    onMouseOverOpen() {
      //开放时间
      if (
        this.form.extInfo.opentime != undefined &&
        this.form.extInfo.opentime != null
      ) {
        this.$refs.openDate.style.display = 'none'
      }
    },
    onMouseleave() {
      this.$refs.iconDate.style.display = 'block' //立项日期
      this.$refs.openDate.style.display = 'block' //开放时间
    },
    handleCancle() {
      // this.form.dialogform.applicant = '';
      // this.form.dialogform.file = '';
      // this.form.dialogform.lawyer2 = '';
    },
    Post(form) {
      this.form.BidFile = this.FileList1.map((v) => {
        return v.uid
      })
      this.form.otherFile = this.FileList2.map((v) => {
        return v.uid
      })
      this.form.FreeFile = this.FileList3.map((v) => {
        return v.uid
      })
      this.form.dialogform.file = this.FileList.map((v) => {
        return v.uid
      })
      var labelArr = []
      var allLawyer = this.form.LeadLawyer.concat(this.form.CoCounsel)
      allLawyer.forEach((item) => {
        this.Lawyer.forEach((value) => {
          if (item == value.id && value.practice) {
            labelArr.push(item.practice)
          }
        })
      })

      if (labelArr.length == allLawyer.length) {
        this.$message.error('实习律师不能单独录案件')
        return
      }
      this.$refs[form].validate((success) => {
        if (success) {
          this.form.dialogform.SealType = this.form.SealType
          // this.FileList = this.FileList1.concat(this.FileList2)
          // this.applyDialog = true
          this.addEnter(form)
          // this.form.dialogform.applicant = this.form.LeadLawyer[0]
          // console.log(this.form.dialogform.file)
          // this.SealChange()
        } else {
          this.$nextTick(() => {
            const errorField = this.$el.querySelector('.el-form-item.is-error')
            if (errorField) {
              errorField.scrollIntoView({ behavior: 'smooth', block: 'center' })
            }
          })
          this.$message.error('有必填项为空')
        }
      })
    },
    addEnter(form) {
      //录入
      // console.log(this.form.extInfo)
      this.$refs['ruleformseal'].validate((success) => {
        if (success) {
          this.isLoading = true
          this.dianji = true
          if (this.form.chargingMethod == '免费') {
            this.form.fixed = null //定额收费金额
            this.form.riskFixed = 0 //半风险中的定额收费金额
            this.form.riskRatio = 0 //风险收费比例
            this.form.bcbdTable = []
          } else if (this.form.chargingMethod == '固定收费') {
            this.form.riskFixed = 0 //半风险中的定额收费金额
            this.form.riskRatio = 0 //风险收费比例
          } else {
            this.form.fixed = null //定额收费金额
            if (this.form.riskFixed == 0) {
              this.form.bcbdTable = []
            }
          }

          if (this.form.extInfo.opentime) {
            this.form.extInfo.opentime = this.JsonTime(
              this.form.extInfo.opentime
            ) //时间格式转换
          }
          this.form.bcbdTable.forEach((element) => {
            if (element.PaymentDate) {
              element.PaymentDate = this.JsonTime(element.PaymentDate)
            }
          })

          // 筛选选中的打印材料
          var newCities = []
          var st = []
          this.form.dialogform.checkedCities.forEach((cv) => {
            this.form.dialogform.cities.forEach((cvc) => {
              if (cv == cvc.name) {
                newCities.push(cvc)
                if (cvc.stype != null && cvc.stype != '') {
                  st.push(cvc.stype)
                }
              }
            })
          })
          var nst = st
            .flat()
            .filter(Boolean)
            .filter(
              (value, index, self) => self.indexOf(value) === index && value
            )
            .join(',')

          BidAdd({
            CaseType: '破产案件投标',
            Title: this.form.title,
            Cause: this.form.cause,
            CaseStatus: this.form.casestatus,
            Approve: this.form.approve, //项目二次审批人
            postTime: this.form.postTime, //立项时间
            Source: this.form.source,
            AcceptUnit: this.form.acceptUnit,
            AcceptCode: this.form.acceptCode,
            LeadLawyer: this.form.LeadLawyer,
            CoCounsel: this.form.CoCounsel,
            ExtInfo: JSON.stringify(this.form.extInfo), //扩展字段
            Bidfile: this.form.BidFile,
            FreeFile: this.form.FreeFile,
            OtherFile: this.form.otherFile,
            ChargingMethod: this.form.chargingMethod,
            AmountOfSubject: this.form.amountOfSubject==""?null: this.form.amountOfSubject,
            Introduction: this.form.introduction,
            Remark: this.form.remark,
            Fixed: this.form.fixed == null ? null : this.form.fixed,
            RiskFixed: this.form.riskFixed == null ? 0 : this.form.riskFixed,
            RiskRatio: this.form.riskRatio == null ? 0 : this.form.riskRatio,
            // BillingDetail: this.form.bcbdTable, //收费明细
            BillingDetail: null,
            // SealType: this.form.sealType, //用章
            SealType: nst,
            newSealTypes: JSON.stringify(newCities),
            ApplicantId: this.form.dialogform.applicant,
            // Approver: this.form.dialogform.approver,
            Seallist: this.form.dialogform.file,
            Reason: this.form.dialogform.reason,
            DepartmentLeaders: this.form.departmentLeaders
            // SealLeaders: this.form.dialogform.SealLeaders
          }).then((res) => {
            if (res.data.status === 'success') {
              // localStorage.removeItem('draftForm' + this.numType)
              // localStorage.removeItem('draftFormType' + this.numType)
              // localStorage.removeItem('draftFormId' + this.numType)
              var cgForm = JSON.parse(
                localStorage.getItem('draftForm' + this.numType)
              )
              // console.log('cgForm', cgForm)
              // console.log('cgid', this.cgid)

              if (cgForm != null) {
                if (cgForm.length == 1) {
                  localStorage.removeItem('draftForm' + this.numType)
                } else {
                  cgForm.forEach((value, index, arr) => {
                    if (value.uuid == this.cgid) {
                      return arr.splice(index, 1)
                    }
                  })
                  localStorage.setItem(
                    'draftForm' + this.numType,
                    JSON.stringify(cgForm)
                  )
                }
              }

              this.$message.success('破产案件投标录入成功，请等待审核!')
              // this.$router.push({
              //   path: `/home/bankrupt/bankruptBid`
              // })
              this.history()
            } else if(res.data.status=='Filefail'){
            this.$message.error(res.data.message)
            this.isLoading = false
            this.dianji = false
            this.FileList1 = []
            this.FileList = []
            this.FileList2 = []
            this.FileList3 = []
          }else if (
              res.data.status == '401' ||
              res.data.status == '402' ||
              res.data.status == '403'
            ) {
              this.$message.error(res.data.message)
              window.sessionStorage.removeItem('token')
              window.sessionStorage.removeItem('hasRoles')
              this.$router.push('/login')
            } else {
              this.$message.error(res.data.message)
            }
            this.isLoading = false
            this.dianji = false
          })
        } else {
          this.$nextTick(() => {
            const errorField = this.$el.querySelector('.el-form-item.is-error')
            if (errorField) {
              errorField.scrollIntoView({ behavior: 'smooth', block: 'center' })
            }
          })
          this.$message.error('有必填项为空')
        }
      })
    },
    // Save(){//保存草稿
    //   const caogao = {
    //         id:this.Createguid(),
    //         caseType:"破产案件投标",
    //         title:this.form.title,
    //         cause:this.form.cause,
    //         name:this.form.name,
    //         approve:this.form.approve,//项目二次审批人
    //         // postTime:this.form.postTime,//立项时间
    //         source:this.form.source,
    //         acceptUnit:this.form.acceptUnit,
    //         leadLawyer:this.form.LeadLawyer,
    //         coCounsel:this.form.CoCounsel,
    //         extInfo:JSON.stringify(this.form.extInfo),//扩展字段
    //         bidfile:this.form.BidFile,
    //         otherFile:this.form.otherFile,
    //         chargingMethod:this.form.chargingMethod,
    //         amountOfSubject:this.form.amountOfSubject,
    //         introduction:this.form.introduction,
    //         remark:this.form.remark,
    //         fixed:this.form.fixed==null?0:this.form.fixed,
    //         riskFixed:this.form.riskFixed==null?0:this.form.riskFixed,
    //         riskRatio:this.form.riskRatio==null?0:this.form.riskRatio,
    //         billingDetail:this.form.bcbdTable,//收费明细

    //   }
    // },
    Createguid() {
      let guid = ''
      for (let i = 1; i <= 32; i++) {
        const n = Math.floor(Math.random() * 16.0).toString(16)
        guid += n
        if (i === 8 || i === 12 || i === 16 || i === 20) {
          guid += '-'
        }
      }
      return guid
    },
    Price(rule, value, callback) {
      var price = /^\d+(\.\d{0,2})?$/
      if (!value) {
        callback(new Error('不能为空'))
      } else if (value <= 0) {
        callback(new Error('请输入大于0的金额'))
      } else if (!price.test(value)) {
        callback(new Error('请输入正确格式的金额')) //防止输入多个小数点
      } else {
        callback()
      }
    },
    // 时间格式
    handleTime(time) {
      // yyyy-MM-dd HH:MM:SS
      var t = new Date(time).toJSON()
      return new Date(+new Date(t) + 8 * 3600 * 1000)
        .toISOString()
        .replace(/T/g, ' ')
        .replace(/\.[\d]{3}Z/, '')
    },
    JsonTime(date) {
      // yyyy-MM-ddT HH:MM:SS
      var t = new Date(date).getTime()
      var d = new Date(t + 8 * 3600 * 1000).toISOString()
      return d
    },

    // 必选标识
    addRedStar(h, { column }) {
      return [
        h('span', { style: 'color: #F56C6C' }, '*'),
        h('span', ' ' + column.label)
      ]
    },
    // 删除草稿
    scCG(scid) {
      // console.log(scid)
      // console.log(this.caoGao)
      if (scid == null) {
        return this.$message.error('请选择要删除的草稿！')
      }
      for (var a = 0; a < scid.length; a++) {
        this.caoGao.forEach((value, index, array) => {
          if (value.uuid == scid[a]) {
            array.splice(index, 1)
          }
        })
      }

      if (this.caoGao.length == 0) {
        localStorage.removeItem('draftForm' + this.numType)
      } else {
        // localStorage.setItem(
        //   'draftForm' + this.numType,
        //   JSON.stringify(this.caoGao)
        // )
      }
      this.$message.success('删除成功')
      this.scDialogVisible = false
      this.centerDialogVisible = false
      this.inputDraftNew()
    },
    // 删除草稿
    deleteCaoGao() {
      // localStorage.removeItem('draftForm' + this.numType)
      // this.$message.success('删除草稿成功！')
      // this.centerDialogVisible = false
      // this.caoGao = []
      // setTimeout(() => {
      //   this.inputDraftNew()
      // }, 1000)
      this.scDialogVisible = true
    },
    // this.numType
    // 全新录入监控
    inputDraft(newVal) {
      var cgForm = JSON.parse(localStorage.getItem('draftForm' + this.numType))
      // console.log('全新录入监控', cgForm)
      // if (cgForm.length > 1) {
      cgForm = cgForm.slice(0, -1)
      cgForm.push(newVal)
      localStorage.setItem('draftForm' + this.numType, JSON.stringify(cgForm))
      // } else {
      //   localStorage.setItem('draftForm' + this.numType, JSON.stringify(newVal))
      // }
    },

    // 全新录入
    async inputDraftNew() {
      this.user()
      this.centerDialogVisible = false
    },

    // 保存草稿
    saveCaoGao() {
      var cgForm = JSON.parse(localStorage.getItem('draftForm' + this.numType))

      var you = false
      if (cgForm != null) {
        cgForm.forEach((value, index, arr) => {
          if (value.uuid == this.cgid) {
            you = true
            return (arr[index] = this.form)
          }
        })
      }

      if (you) {
        // 再次写入local
        localStorage.setItem('draftForm' + this.numType, JSON.stringify(cgForm))
      } else {
        this.form.draftFormType = this.numType
        this.form.draftFormId = window.sessionStorage.getItem('userId')
        this.form.uuid = this.guid()
        if (cgForm == null || cgForm == []) {
          this.caoGao.push(this.form)
          localStorage.setItem(
            'draftForm' + this.numType,
            JSON.stringify(this.caoGao)
          )
        } else {
          cgForm.push(this.form)
          localStorage.setItem(
            'draftForm' + this.numType,
            JSON.stringify(cgForm)
          )
        }
      }
      this.$message.success('保存成功！')
    },

    // // 修改草稿
    // updateCaoGao() {
    //   // 取出local数据并修改
    //   var cgForm = JSON.parse(localStorage.getItem('draftForm' + this.numType))
    //   cgForm.forEach((value, index, arr) => {
    //     if (value.uuid == this.cgid) {
    //       return (arr[index] = this.form)
    //     }
    //   })

    //   // 再次写入local
    //   localStorage.setItem('draftForm' + this.numType, JSON.stringify(cgForm))

    //   this.$message.success('修改成功！')
    // },

    // 取出选择的草稿
    cgInput(cgid) {
      if (cgid == null || cgid == '') {
        return this.$message.error('请选择草稿')
      }

      var cgForm = JSON.parse(localStorage.getItem('draftForm' + this.numType))
      cgForm.forEach((v, i, arr) => {
        if (v.uuid == cgid) {
          return (this.form = v)
        }
      })
      this.user(this.form.LeadLawyer)
      this.form.dialogform.file = []
      // option改变事件
      // this.SF_Chargestatus(this.form.chargingMethod)
      // this.LeadLawyerChange(this.form.leadLawyer)
      // this.bmzgChange()
      this.SealChange()

      this.caoGao1 = true
      this.cgDialogVisible = false
      this.centerDialogVisible = false
    },

    // 原有草稿录入监控
    inputDraftOld(nv) {
      // 取出local数据并修改
      var cgForm = JSON.parse(localStorage.getItem('draftForm' + this.numType))
      cgForm.forEach((value, index, arr) => {
        if (value.uuid == this.cgid) {
          return (arr[index] = nv)
        }
      })

      // 再次写入local
      // console.log('再次写入local', cgForm)
      localStorage.setItem('draftForm' + this.numType, JSON.stringify(cgForm))
    },

    // 判断当前案件是否存在草稿
    caoGaoSelect() {
      var cgForm = JSON.parse(localStorage.getItem('draftForm' + this.numType))
      // console.log(cgForm)
      // console.log(cgForm.length)
      if (cgForm != null) {
        if (cgForm.length > 0) {
          cgForm.forEach((value, index, arr) => {
            if (value.draftFormId == window.sessionStorage.getItem('userId')) {
              this.caoGao.push(value)
              this.my = true
            }
          })
          if (this.my) {
            this.centerDialogVisible = true
          } else {
            this.inputDraftNew()
          }
        }
      } else {
        this.inputDraftNew()
      }
    },

    // 草稿录入
    caoGaoInput() {
      // this.form = JSON.parse(localStorage.getItem('draftForm' + this.BidId))
      // this.SF_Chargestatus(this.form.chargingMethod)
      // this.LeadLawyerChange(this.form.leadLawyer)
      // this.bmzgChange()
      // this.centerDialogVisible = false
      this.cgDialogVisible = true
    },

    S4() {
      return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1)
    },
    // guid生成
    guid() {
      return (
        this.S4() +
        this.S4() +
        '-' +
        this.S4() +
        '-' +
        this.S4() +
        '-' +
        this.S4() +
        '-' +
        this.S4() +
        this.S4() +
        this.S4()
      )
    },
    inputType() {
      this.form.dialogform.cities = [
        {
          name: '案件审批单', // 模板名
          stype: ['official_seal'], // 用章类型
          type: 2
        }
      ]
      if (this.form.dialogform.checkedCities.length > 0) {
        this.form.dialogform.checkedCities = []
      }
      this.form.dialogform.cities.forEach((value) => {
        this.form.dialogform.checkedCities.push(value.name)
      })
    },

    // 用章类型改变,查找审批人
    async GetSealLevel() {
      // console.log(this.form.dialogform.cities)
      if (
        this.form.dialogform.applicant == '' ||
        this.form.dialogform.applicant == null
      ) {
        return
      }
      var newSeal = []
      // console.log(this.form.dialogform.cities)
      this.form.dialogform.cities.forEach((value) => {
        if (value.stype.length > 0) {
          newSeal.push(value.stype.join(','))
        }
      })
      var uniqueArr = [...new Map(newSeal.map((item) => [item, item])).values()]
      var news = Array.from(
        new Set(uniqueArr.flatMap((item) => item.split(',')))
      )
      if (JSON.stringify(news) !== JSON.stringify(this.selectedSealType)) {
        this.GetSealApprove()
        this.selectedSealType = news
      }
    }
  },
  async created() {
    this.caoGaoSelect()
    this.inputType()
    await this.GetSealLevel()
    //   this.$watch(
    //     'form',
    //     (newVal, oldVal) => {
    //       console.log('保存草稿', newVal)
    //       this.inputDraft(newVal)
    //     },
    //     { deep: true }
    //   )
  },
  watch: {
    caoGao1: {
      handler(newValue, oldValue) {
        if (newValue) {
          this.$watch(
            'form',
            (newVal, oldVal) => {
              // console.log('保存草稿old', newVal)
              // this.inputDraftOld(newVal)
            },
            { deep: true }
          )
        }
      },
      deep: true
    },

    newcaoGao1: {
      handler(newValue, oldValue) {
        if (newValue) {
          this.$watch(
            'form',
            (newVal, oldVal) => {
              // console.log('保存草稿new', newVal)
              // this.inputDraft(newVal)
            },
            { deep: true }
          )
        }
      },
      deep: true
    }
  },
  mounted() {}
}
</script>
    
<style lang="less" scoped>
#Bidinput {
  width: 100%;
}

#Bidinput .title {
  width: 100%;
  text-align: center;
  margin-bottom: 20px;
}

#Bidinput .main {
  width: 99%;
  margin: auto;
  padding-bottom: 30px;
}

#Bidinput .main_card {
  width: 100%;
  border-radius: 12px;
  padding-bottom: 20px;
}

#Bidinput .case {
  width: 100%;
  margin: auto;
  margin-top: 40px;
}

#Bidinput .top {
  width: 100%;
  display: flex;
  color: #3077e6;
  align-items: center;
  font-size: 19px;
  font-weight: 400;
  padding-left: 58px;
  margin-bottom: 32px;
}
// 弹出框
/deep/.el-dialog__header {
  padding: 10px 10px 10px;
  background: rgba(250, 250, 250, 1);
  font-size: 18px;
}

#Bidinput .icon {
  width: 4px;
  height: 18px;
  background: #3077e6;
  border-radius: 9px;
  margin-right: 5px;
}

#Bidinput .contain {
  width: 100%;
}

#Bidinput /deep/ .el-form-item__label {
  font-size: 17px;
  font-weight: 400;
}

#Bidinput .select {
  width: 100%;
}

#Bidinput .divider {
  width: calc(100% - 50px);
  float: right;
  border-top: 1px solid rgba(238, 239, 242, 1);
  margin-bottom: 32px;
  margin-top: 10px;
}

// 日历
#Bidinput ::v-deep .el-input__prefix {
  display: none;
}

#Bidinput .date_box ::v-deep .el-input--prefix .el-input__inner {
  padding-left: 15px;
}

#Bidinput .date_box {
  .el-icon-date {
    position: absolute;
    top: 50%;
    right: 10px;
    z-index: 0;
    color: #c0c4cc;
    font-size: 14px;
    transform: translateY(-50%);
  }

  /deep/ .el-range__close-icon {
    position: absolute;
    right: 34px;
    top: 54%;
    transform: translateY(-50%);
  }
}

#Bidinput .fjchoose {
  border: 1px solid rgba(48, 119, 230, 1);
  font-size: 16px;
  font-weight: 400;
  color: rgba(48, 119, 230, 1);
}

#Bidinput .money /deep/ .el-form-item__content {
  display: flex;
  align-items: center;
}

//按钮
#Bidinput .allbtn {
  width: 100%;
  text-align: center;
  // margin-top: 80px;
  position: fixed;
  top: 98%; /* 距顶部居中显示 */
  left: 50%; /* 距左侧居中显示 */
  transform: translate(-50%, -50%); /* 水平、垂直居中 */
  z-index: 999;
  background-color: #f5f5f5;
}

#Bidinput .history {
  border: 1px solid rgba(43, 200, 135, 1);
  color: rgba(43, 200, 135, 1);
}

// 附件回显
#Bidinput .upload_file {
  width: 360px;
}

#Bidinput .file_show {
  width: 360px;
}

#Bidinput .fj {
  // display: inline-flex;
  display: flex;
  align-items: center;
  background: #f5f7fa;
  justify-content: flex-start;
  padding: 10px;
  padding-right: 20px;
  margin-bottom: 10px;
}

#Bidinput img {
  width: 100%;
  height: 100%;
}

#Bidinput .name {
  display: inline-flex;
  flex-direction: column;
  padding-left: 10px;
}
#Bidinput .fname {
  width: 280px;
  text-overflow: ellipsis;
  /* ellipsis:显示省略符号来代表被修剪的文本  string:使用给定的字符串来代表被修剪的文本*/
  white-space: nowrap;
  /* nowrap:规定段落中的文本不进行换行   */
  overflow: hidden;
  /*超出部分隐藏*/
}

#Bidinput .word {
  line-height: 24px;
  cursor: default;
}
#Bidinput /deep/.el-form-item__content {
  line-height: 24px;
  position: relative;
  font-size: 14px;
}

#Bidinput .look {
  color: #fe964a;
  margin-right: 10px;
}

#Bidinput .down {
  color: #2bc887;
  margin-right: 10px;
}

#Bidinput .del {
  color: hsl(356, 93%, 50%);
}

//进度条
#Bidinput .uploadprocess {
  width: 360px;
}

#Bidinput .uploadname {
  width: 320px;
  text-overflow: ellipsis;
  /* ellipsis:显示省略符号来代表被修剪的文本  string:使用给定的字符串来代表被修剪的文本*/
  white-space: nowrap;
  /* nowrap:规定段落中的文本不进行换行   */
  overflow: hidden;
  /*超出部分隐藏*/
}

#Bidinput .jdtext {
  width: 360px;
  display: flex;
}

#Bidinput .per {
  width: 40px;
  text-align: right;
}

/deep/ .el-progress-bar__outer {
  //进度条的高度
  height: 4px !important;
}
//收费明细
.addrow {
  float: right;
  margin-bottom: 10px;
  z-index: 1;

  .el-icon-plus {
    color: #fe964a;
    cursor: pointer;
  }
}

//表格
.detail::v-deep .el-table th.el-table__cell {
  overflow: hidden;
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
  background-color: #fafafa;
}

.party {
  margin-bottom: 55px;
  margin-left: 5%;
  ::v-deep .el-input__inner {
    padding-left: 0;
  }
  ::v-deep .el-input__inner {
    border: none;
    // height: 24px;
    // line-height: 24px;
    text-align: center;
  }

  ::v-deep .el-input--prefix .el-input__inner {
    padding-left: 0px;
  }
}

::v-deep tbody tr:hover > td {
  background-color: transparent !important;
}

/deep/ .el-table th {
  //标题背景色
  background-color: #fafafa;
}

.copy {
  color: #3077e6;
  cursor: pointer;
}

.bgdel {
  color: #fe964a;
  margin-left: 8px;
  cursor: pointer;
}
.party /deep/.el-input__icon {
  height: 100%;
  width: 25px;
  text-align: center;
  transition: all 0.3s;
  line-height: 24px;
}

.yz_input {
  ::v-deep .el-input__inner {
    width: 300px !important;
  }
}
::v-deep .el-form-item {
  margin-bottom: 16px !important;
}
</style>